module.exports = __webpack_public_path__ + "img/core_m_3.ab087e77.png";